
import { useEffect, useState } from 'react';

const BrandManifesto = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('brand-manifesto');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const manifestoLines = [
    '我们相信，真正的美丽源于内在的和谐',
    '千年宫廷古方，承载着东方智慧的精髓',
    '现代科学验证，确保每一份产品的安全与功效',
    '内调外养，让身心达到最佳的平衡状态',
    '养于内，美于外，这是我们对美好生活的诠释'
  ];

  return (
    <section 
      id="brand-manifesto" 
      className="py-20 lg:py-40 relative overflow-hidden"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="max-w-4xl mx-auto px-8 text-center relative z-10">
        {/* Section Title */}
        <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <h2 
            className="text-2xl lg:text-3xl font-light text-black mb-16"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100 }}
          >
            品牌宣言
          </h2>
          <div className="w-32 h-px mx-auto mb-16" style={{ background: 'linear-gradient(to right, transparent, #FDF8C7, transparent)' }}></div>
        </div>

        {/* Manifesto Content */}
        <div className="space-y-12 mb-20">
          {manifestoLines.map((item, index) => (
            <div
              key={index}
              className={`transform transition-all duration-1000 ${
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              }`}
              style={{ transitionDelay: `${(index + 1) * 400}ms` }}
            >
              <p 
                className="text-xs lg:text-lg text-stone-700 leading-relaxed font-light"
                style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100 }}
              >
                {item}
              </p>
            </div>
          ))}
        </div>

        {/* Decorative Line */}
        <div className={`flex justify-center mb-16 transform transition-all duration-1000 delay-2000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <div className="w-32 h-px" style={{ background: 'linear-gradient(to right, transparent, #FDF8C7, transparent)' }}></div>
        </div>

        {/* Brand Image */}
        <div className="mb-16">
          <img
            src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/cd97cfee90b79d4eb4ba70364349f66f.png"
            alt="宫廷养森"
            className="h-4 lg:h-8 w-auto object-contain mx-auto"
          />
        </div>

      </div>

      {/* Background Decorative Elements */}
      <div className="absolute top-1/4 left-1/6 w-4 h-4 bg-red-600/10 rounded-full animate-pulse"></div>
      <div className="absolute top-1/3 right-1/5 w-2 h-2 bg-red-600/20 rounded-full animate-pulse delay-1000"></div>
      <div className="absolute bottom-1/4 right-1/6 w-6 h-6 bg-red-600/10 rounded-full animate-pulse delay-500"></div>
    </section>
  );
};

export default BrandManifesto;
